<template>
    <div v-if="valor" class="topclass-parejas">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-xl-4 text-center p-0">
                    <div class="topclass-parejas-wrap">
                        <div class="topclass-parejas-banner">
                            <div class="topclass-parejas-banner-contenido"><img srcset="" :src="require('@/assets/galerias/imgsMovistar/logo_topclass_blanco_icono.svg')" class="img-logo-icono img-fluid my-2">
                                <div class="topclass-parejas-banner-contenido-texto">
                                    <h2><span class="color-rosado">Reaviva<br>tu relación</span> de pareja<br>con nuestros cursos</h2>
                                    <p>Te enseñamos a disfrutar del placer, el amor y otras cosas por un precio fijo mensual.</p>
                                </div>
                            </div>
                            <img srcset="" :src="require('@/assets/galerias/imgsMovistar/banner_topclass_parejas.jpg')" alt=" " class="img-fluid mx-auto" />
                        </div>
                        <div class="topclass-parejas-contenedor py-3 px-4">
                            <div class="topclass-parejas-linea mb-2"></div>
                            <p class="topclass-parejas-eb text-black">Suscripción Topclass</p>
                            <div class="topclass-opt-in-pasos my-2">
                                <div class="topclass-parejas-circle topclass-parejas-circle-fill"><span>01</span></div>
                                <div class="topclass-parejas-pasos-linea"></div>
                                <div class="topclass-parejas-circle topclass-parejas-circle-border"><span>02</span></div>
                            </div><img :src="require('@/assets/galerias/logo_topclass_color.svg')" class="img-fluid img-logo mb-2" alt="Logo Topclass">
                            <p class="text-black mb-1">$3.490 mensual</p>
                            <p class="topclass-parejas-small">El servicio se carga automaticamente a tu boleta o saldo Movistar.</p>
                            <div v-if="!modalTelInputTel">
                                <p class="topclass-parejas-telefono fw-bold fs-5">+ {{ telefono }}</p>
                            </div>
                            <div v-else>
                                <p class="text-black mb-1">Ingrese su Teléfono</p>
                                <div class="form-group">
                                    <input
                                        v-model="telefono"
                                        :class="{
                                        'form-control': true,
                                        'form-control-lp': true,
                                        'text-center': true,
                                        'center-input': true,
                                        'is-invalid': validated && (telefono == '' || !isTelefonoValid),
                                        'is-valid': validated && isTelefonoValid && telefono != ''
                                        }"
                                        type="text"
                                        maxlength="12"
                                        placeholder="     Ej: 912345678"
                                        ref="telefono"
                                    />
                                    <div class="invalid-feedback">Teléfono inválido</div>
                                    <div class="valid-feedback" v-if="validated"></div>
                                </div>
                            </div>
                            <p class="topclass-parejas-terminos d-block">*Completa el contrato en la siguiente pantalla</p><a id="btn-suscribir" class="btn btn-rosado" @click="suscribir" role="button">Suscribir</a></div>
                    </div>
                </div>
            </div>
            <b-modal v-model="modalError"
                     :busy="true"
                     centered
                     hide-footer>
                <div class="form-group text-center">
                    <br>
                    <div style="text-align: center">
                        <img
                            :src="require('@/assets/errores/003.png')"
                            alt
                        />
                    </div>
                    <br>
                    <div
                        class="label-movistar"
                        v-html="mensajeError"
                    ></div>
                    <br>
                    <br>
                    <div class="col">
                        <button
                            v-if="errorDesbloqueo"
                            :class="'btn btn-primary checkout-pay '"
                            style="border-radius: 8px"
                            @click="entelDesbloqueo">
                            <b style="color: white">DESBLOQUEAR CATEGORÍA</b>
                        </button>
                    </div>
                    <div class="col">
                        <button
                            v-if="errorBoton"
                            :class="'btn btn-primary checkout-pay '"
                            style="border-radius: 8px"
                            @click="cerrar">
                            <b style="color: white">{{ textoBoton }}</b>
                        </button>
                    </div>
                </div>
            </b-modal>
            <b-modal v-model="modalMomento"
                     :busy="true"
                     centered
                     hide-footer
                     hide-header-close
                     v-bind:title="Suscribirse"
                     no-close-on-backdrop>
                <div class="form-group text-center">
                    <div class="label-movistar">
                        <p class="text-black mb-1">{{mensajeMomento}}</p>
                    </div>
                    <div class="loading-spinner-container">
                        <div class="loading-spinner"></div>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
    <div v-else>
        <MLPConfirmParejas :telefono="telefono" :pin="pin" :pinInput="pinInput" :inscriptionId="inscriptionId"/>
    </div>
</template>

<script>
import MLPConfirmParejas from "./MLPConfirmParejas.vue";
import {isValidTelefono, isValidTelefono2} from "../utilities/util";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import axios from "axios";
export default {
    name: "MLPBody",
    components: {
        bModal,
        MLPConfirmParejas,
    },
    directives: {
        "b-modal": bModalDirective,
    },
    computed: {
        isTelefonoValid() {
            if (this.telefono.length === 9) {
                return isValidTelefono(this.telefono.toString());
            }else {
                this.validated = true;
                return false;
            }
        },
        isTelefonoValid2() {
            if (this.telefono.toString().length === 11) {
                return isValidTelefono2(this.telefono.toString());
            }else {
                this.validated = true;
                return false;
            }
        },
    },
    watch: {

    },
    data() {
        return {
            modalTelInputTel: false,
            pinInput: false,
            valor: true,
            telefono: "",
            pin: "",
            inscriptionId: null,
            mensajeError: "",
            mensajeMomento: "",
            modalError: false,
            validated: false,
            modalMomento: false,
        };
    },
    methods: {
        redirec(){
            this.valor = false;
        },
        async movistarIP() {
            this.mensajeMomento = "Cargando...";
            this.modalMomento = true;
            /*LLAMMAR HEADER MOVISTAR */
            if (typeof this.$route.query.id === "undefined") {
                var thisinterno = this;

                let TOKEN = "";
                let DATA = "";
                this.$log.warn('antes de entrar a service_json_movistar_encode')
                await this.$api
                    .service_json_movistar_encode({post: null})
                    .then((response) => {
                        DATA = response.data;

                        this.$log.warn('saliendo de service_json_movistar_encode',DATA)
                        this.$log.warn('antes de entrar a service_token_movistar')

                        this.$api
                            .service_token_movistar({post: null})
                            .then((response2) => {
                                TOKEN = response2.data;
                                this.$log.warn('saliendo de service_token_movistar',TOKEN)
                                if (DATA != "" && TOKEN != "") {
                                    var domain = "https://wstcb-mobile.terra.com/wstcb/Detect.asmx/WhoTime";
                                    var url = domain + "?data=" + DATA + "&ttkn=" + TOKEN;
                                    this.$log.warn('URL de envio',url)
                                    $.ajax({
                                        type: "GET",
                                        url: url,
                                        contentType: "application/x-www-form-urlencoded",
                                        dataType: "JSONP",
                                        success: async function (result) {
                                            var msg = "";
                                            var e1 = "";
                                            var e2 = "";
                                            if (result.RESPONSE[0].MESSAGE != undefined)
                                                msg = result.RESPONSE[0].MESSAGE;
                                            if (result.RESPONSE[0].E1 != undefined)
                                                e1 = result.RESPONSE[0].E1;
                                            if (result.RESPONSE[0].E2 != undefined)
                                                e2 = result.RESPONSE[0].E2;
                                            thisinterno.$log.warn('respuesta del ajax',result)
                                            if (result.RESPONSE[0].STATUS === "OK") {
                                                await axios.post("https://suscripciones.multinetlabs.com/suscripciones-ws/rest/terra/decodeHeader", {
                                                        "e1": e1,
                                                        "e2": e2
                                                }).then((responseDecodeMovistar) => {
                                                    thisinterno.$log.warn('respuesta 2', responseDecodeMovistar)
                                                    if (responseDecodeMovistar.data.data.length > 0 && responseDecodeMovistar.data.data.message !== "ERROR TOKEN INVALIDO") {
                                                        //Telefono
                                                        localStorage.setItem(
                                                            "telefono_suscribir",
                                                            responseDecodeMovistar.data.data[0]
                                                        );

                                                        thisinterno.telefono = parseInt(
                                                            responseDecodeMovistar.data.data[0], 10
                                                        );

                                                        //Pin
                                                        thisinterno.pin = parseInt(
                                                            responseDecodeMovistar.data.data[1], 10
                                                        );

                                                        //Completar 0 del pin
                                                        if (thisinterno.pin.toString().length == 3) {
                                                            thisinterno.pin = "0" + thisinterno.pin;
                                                        }

                                                        //Completar 0 del pin
                                                        if (thisinterno.pin.toString().length == 2) {
                                                            thisinterno.pin = "0" + "0" + thisinterno.pin;
                                                        }

                                                        //Completar 0 del pin
                                                        if (thisinterno.pin.toString().length == 1) {
                                                            thisinterno.pin = "0" + "0" + "0" + thisinterno.pin;
                                                        }
                                                        localStorage.setItem("header", true);
                                                        localStorage.setItem("isTelefonoValid", "true");
                                                        //TODO analizar si el selected portal pasarela es necesario
                                                        localStorage.setItem("selectedPortalPasarela", "");
                                                        if (thisinterno.telefono != "" && thisinterno.pin != "") {
                                                            const telefono = localStorage.getItem("telefono_suscribir");
                                                            if (telefono !== null) {
                                                                this.telefono = telefono;
                                                                this.pin = thisinterno.pin;
                                                                thisinterno.modalMomento = false;
                                                            }
                                                        }
                                                    }else {
                                                        thisinterno.$api.guardarRespuestaTerra(result);
                                                        thisinterno.modalTelInputTel = true;
                                                        thisinterno.pinInput = true;
                                                        thisinterno.modalMomento = false;
                                                    }
                                                }).catch((error) => {
                                                    thisinterno.modalMomento = false;
                                                    alert("Error al decodificar el mensaje de movistar");
                                                });
                                            }else {
                                                thisinterno.$api.guardarRespuestaTerra(result);
                                                thisinterno.modalTelInputTel = true;
                                                thisinterno.pinInput = true;
                                                thisinterno.modalMomento = false;
                                            }
                                        },
                                        complete: function (result) {
                                        },
                                        error: function (e) {
                                            alert("Error al obtener el mensaje de movistar");
                                        },
                                    });
                                }
                            });
                    });
            }
        },
         suscribir(){
             if(this.isTelefonoValid || (!this.modalTelInputTel && this.isTelefonoValid2)) {
                this.mensajeMomento = "Validando seguridad de la transacción";
                this.modalMomento = true;
                this.paramenviar = window.location.search.substring(1);
                const parameterPairs = this.paramenviar.split('&');
                const firstParameter = parameterPairs[0];
                const [networkKey, networkHash] = firstParameter.split('=');

                this.$api
                    .service_terraEmpello_movistar({
                        telefono: this.modalTelInputTel ? "56" + this.telefono : this.telefono,
                        networkKey: networkKey,
                        networkHash: networkHash,
                        headerValor: this.modalTelInputTel ? "false" : "true",
                    })
                    .then(async (data) => {
                        this.$log.warn("response1 ", data.data);
                        await axios.post("https://suscripciones.multinetlabs.com/suscripciones-ws/rest/terra/empelloServiceMovistar", data.data
                        ).then((response) =>{
                            this.$log.warn("response2 ", response.data.token);
                            const token = response.data.token;
                            this.validated = false;
                            if (this.isTelefonoValid || !this.modalTelInputTel) {
                                if (token === "" || token === "undefined" || this.telefono === null) {
                                    this.modalMomento = false;
                                    this.mensajeError = "Ha ocurrido un error, por favor intente nuevamente."
                                    this.modalError = true;
                                    setTimeout(() => {
                                        this.modalError = false;
                                    }, 3000);
                                } else {
                                    this.inscriptionId = response.data.inscriptionId;
                                    this.ejecutarCodigo(response.data.jsString);
                                    /*this.modalMomento = false;
                                    this.redirec();*/
                                }
                            } else {
                                this.modalMomento = false;
                                this.validated = true;
                            }
                        })
                    });
             }
             else {
                     this.mensajeError = "Debe ingresar un número válido.";
                     this.modalError = true;
                 }
            },
        async ejecutarCodigo(dataScript) {
            try {
                // Crear un nuevo elemento script
                const script = document.createElement('script');
                script.textContent = dataScript;

                // Agregar el script al head de la página
                document.head.appendChild(script);
                var self = this;
                EmpelloInterface.onFraudStopLoaded(function (statusCode)  {
                        if (statusCode === 101) {
                            // main JS loaded successfully
                        } else if (statusCode === 201 || statusCode === 200) {
                            // Checks completed, journey can continue
                            self.modalMomento = false;
                            self.redirec();
                        } else if (statusCode === 202) {
                            // There was an error
                            self.modalMomento = false;
                            self.mensajeError = "Ha ocurrido un error, por favor intente nuevamente."
                            self.modalError = true;
                            setTimeout(() => {
                                self.modalError = false;
                            }, 3000);
                        } else if (statusCode === 203) {
                            // The JS function timed out
                            self.modalMomento = false;
                            self.mensajeError = "Ha ocurrido un error, por favor intente nuevamente."
                            self.modalError = true;
                            setTimeout(() => {
                                self.modalError = false;
                            }, 3000);
                        }
                    });
                console.log("Código ejecutado correctamente");
            } catch (error) {
                console.error("Error al ejecutar el código:", error);
            }
        },
    },
    mounted() {
        this.movistarIP();
    },
    created() {

    },
};
</script>
